import { render, staticRenderFns } from "./tab2.vue?vue&type=template&id=f31620e8&scoped=true"
import script from "./tab2.vue?vue&type=script&lang=js"
export * from "./tab2.vue?vue&type=script&lang=js"
import style0 from "./tab2.vue?vue&type=style&index=0&id=f31620e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31620e8",
  null
  
)

export default component.exports